import { Logger } from 'wdc-cube'
import { ValueProperty } from '../tcm_filter_manager'
import {
    FilterExtraAeScope,
    JunctionMode,
    KeywordOption,
    MultipleOptionStringKeywordFilterScope,
    MultipleOptionStringKeywordParcelFilterScope
} from '../tcm_scopes'
import { MultipleStringKeywordFilter, TipoAtividadeEconomicaCodeFilter } from '../tcm_service'
import { TcmPresenterForStringMultiSelectFilter } from './tcm_filter_presenter_for_string_multi_select'
import { TcmPresenterForFilterPane } from './tcm_presenter_filter_pane'

const LOG = Logger.get('TCM-AEFilter')

export class TcmPresenterForAtivEconomica extends TcmPresenterForStringMultiSelectFilter {
    defaultDomain = 1

    constructor(
        owner: TcmPresenterForFilterPane,
        scope: MultipleOptionStringKeywordFilterScope,
        valueProperty: ValueProperty<MultipleStringKeywordFilter>,
        onSearch?: () => Promise<KeywordOption[]>
    ) {
        super(owner, scope, valueProperty, onSearch)
    }

    populateUsingValueProporty(domain: number) {
        const oldDefaultDomain = this.defaultDomain
        try {
            this.scope.conjunction.length = 0
            this.scope.disjunction.length = 0

            for (const entry of this.valueProperty.values() as IterableIterator<TipoAtividadeEconomicaCodeFilter>) {
                this.defaultDomain = entry.domain ?? domain
                const entryScope = entry.mode === JunctionMode.AND ? this.addConjuntion() : this.addDisjuntion()
                entryScope.operator = entry.operator
                entryScope.value = entry.value ?? []
            }
        } finally {
            this.defaultDomain = oldDefaultDomain
        }
    }

    override addConjuntion(): MultipleOptionStringKeywordParcelFilterScope {
        const andScope = super.addConjuntion()
        const extraScope = new FilterExtraAeScope()
        extraScope.domain = this.defaultDomain
        extraScope.onChange = this.action(this.onDomainChange.bind(this, extraScope))
        extraScope.update = this.update
        andScope.extra = extraScope
        return andScope
    }

    override addDisjuntion(): MultipleOptionStringKeywordParcelFilterScope {
        const orScope = super.addDisjuntion()
        const extraScope = new FilterExtraAeScope()
        extraScope.domain = this.defaultDomain
        extraScope.onChange = this.action(this.onDomainChange.bind(this, extraScope))
        extraScope.update = this.update
        orScope.extra = extraScope
        return orScope
    }

    protected async onDomainChange(domainScope: FilterExtraAeScope, value: number) {
        domainScope.domain = value
        LOG.debug(`onDomainChange(value=${value})`)
    }

    protected override populateWithExtraValues(
        filter: TipoAtividadeEconomicaCodeFilter,
        parcelScope: MultipleOptionStringKeywordParcelFilterScope
    ) {
        if (parcelScope.extra) {
            const extraScope = parcelScope.extra as FilterExtraAeScope
            filter.domain = extraScope.domain
        }
        return filter
    }

    apply(filters: TipoAtividadeEconomicaCodeFilter[] | null | undefined) {
        if (!filters || filters.length === 0) {
            return
        }

        filters.forEach((filter) => {
            if (!filter.value) {
                return
            }

            this.defaultDomain = filter.domain ?? this.defaultDomain

            let itemScope: MultipleOptionStringKeywordParcelFilterScope
            if (filter.mode === JunctionMode.AND) {
                itemScope = this.addConjuntion()
            } else {
                itemScope = this.addDisjuntion()
            }

            itemScope.value = filter.value ?? ''
            itemScope.operator = filter.operator
        })
    }
}
